import React from 'react';

interface CartIConProps {
  fill: string;
  width?: number;
  height?: number;
}

const CartICon = ({
                    fill = 'black',
                    width = 29,
                    height = 29
                  }: CartIConProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      id='header_icons_cart_empty'
      data-name='header icons / cart / empty'
      width={width}
      height={height}
      viewBox='0 0 29 29.001'
    >
      <path
        id='Combined_Shape'
        data-name='Combined Shape'
        d='M20.077,26.212A2.789,2.789,0,1,1,22.866,29,2.791,2.791,0,0,1,20.077,26.212Zm1.341,0a1.448,1.448,0,1,0,1.448-1.448A1.45,1.45,0,0,0,21.418,26.212Zm-12.495,0A2.789,2.789,0,1,1,11.712,29,2.79,2.79,0,0,1,8.924,26.212Zm1.34,0a1.449,1.449,0,1,0,1.448-1.448A1.45,1.45,0,0,0,10.264,26.212Zm.691-5.019a1.565,1.565,0,0,1-1.549-1.2L5.211,1.243H.635A.629.629,0,0,1,0,.622.629.629,0,0,1,.635,0h4.89a.3.3,0,0,1,.08.013h.012A.463.463,0,0,1,5.726,0a.645.645,0,0,1,.338.1A.6.6,0,0,1,6.34.491L7.409,5.264H28.366a.628.628,0,0,1,.634.62v.144a.692.692,0,0,1-.015.137l-2.2,9.332a.417.417,0,0,1-.027.085,1.624,1.624,0,0,1-1.519,1.067H9.956l.689,3.073a.307.307,0,0,0,.311.23H25.286a.62.62,0,1,1,0,1.24Z'
        fill={fill}
      />
    </svg>
  );
};

export default CartICon;
